import React, { useEffect, useState } from 'react';

import {
    deleteDocumentLocks,
    lockDocument,
} from '../pages/api/api';
import DeleteModal from './DeleteModal';
import { showErrorToast } from './commonfunction';

interface LockDocumentProps {
    docId: number;
    lockOwner: string;
    isCalledFromGrid: boolean;
    onUnlock: () => void;
}

const LockBar: React.FC<LockDocumentProps> = ({
    docId,
    lockOwner,
    isCalledFromGrid,
    onUnlock,
}) => {
    const [showModal, setShowModal] = useState(false);
    const [adminLocks, setAdminLocks] = useState(false);

    useEffect(() => {
        checkAdminLocks();
    }, [docId]);

    const checkAdminLocks = () => {
        const userDetail = localStorage.getItem('user_details');
        const parsedUserDetail = userDetail ? JSON.parse(userDetail) : null;
        const claims = parsedUserDetail?.claims || [];
        if (claims.includes('adminlocks')) {
            setAdminLocks(true);
        }
    };

    const deleteLock = async () => {
        try {
            const response = await deleteDocumentLocks([{ itemNum: docId }])
            if (response?.status === 403 || response?.status === 400) {
                showErrorToast('Failed to delete a lock');
            } else if (response?.status === 200) {
                onUnlock();
                await lockDocument(docId);
            }
        } catch (error) {
            console.error('Failed to delete a lock:', error);
        }
    };
    return (
        <>
            <div className={isCalledFromGrid ? 'talkbubble' : 'lock-message'}>
                <i className='fa fa-lock' aria-hidden='true' />
                Document Locked.{' '}
                <span style={{ color: 'black', fontWeight: 600 }}>
                    {lockOwner && lockOwner.trim() !== ''
                        ? lockOwner
                        : 'Someone'}
                </span>{' '}
                is working on this document.
                {adminLocks && !isCalledFromGrid && (
                    <span
                        onClick={() => setShowModal(true)}
                        title='Unlock'
                        style={{
                            marginLeft: '5px',
                            cursor: 'pointer',
                        }}
                    >
                        <i
                            className='fas fa-unlock-keyhole'
                            style={{
                                color: 'black',
                                fontSize: '14px',
                            }}
                        ></i>
                    </span>
                )}
            </div>
            <DeleteModal
                deleteModel={showModal}
                setDeleteModel={setShowModal}
                onDelete={deleteLock}
                title='Unlock Document'
                warningText='Are you sure you want to remove the lock on this document?'
                actionButtonText='Remove'
            />
        </>
    );
};

export default LockBar;
